/**
 * Creates the bulk upload worker. Kept on its own because Jest can't parse `import.meta`, so specs of
 * UploadService mock this module instead of the whole service.
 */
export function createUploadWorker(): Worker {
  return new Worker(new URL('upload.worker.ts', import.meta.url));
}
